import * as React from 'react'
import * as ReactDOM from 'react-dom'
import Boot from './boot'
import './index.scss'
import { unregister as unregisterServiceWorker } from './registerServiceWorker'

ReactDOM.render(<Boot />, document.getElementById('root') as HTMLElement)
unregisterServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx